import "font-awesome/css/font-awesome.min.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import NPS from "./Component/NPS";
import NPSV2 from "./Component/NPSV2";
import SingleChoice from "./Component/SingleChoice";
import Email from "./Component/Email";
import Number from "./Component/Number";
import Dropdown from "./Component/Dropdown";
import YesNo from "./Component/YesNo";
import Date from "./Component/Date";
import MultipleChoice from "./Component/MultipleChoice";
import TextBox from "./Component/TextBox";
import MultiLineText from "./Component/MultiLineText";
import RatingScale from "./Component/RatingScale";
import { HiOutlineLightBulb } from "react-icons/hi2";
import { FiCheckCircle } from "react-icons/fi";
import moment from "moment";
import { IoTimeOutline } from "react-icons/io5";

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarningModal: false,
      warningShown: false,

      showRestrictModal: false,
      showFinalSubmitModal: false
    };

    // =========================
    // Anti Cheat
    // =========================
    this.cheatingLog = {
      tabSwitchCount: 0,
      blurCount: 0,
      fullscreenExitCount: 0,
      copyCount: 0,
      pasteCount: 0,
      cutCount: 0,
      rightClickCount: 0,
      refreshCount: 0,
      devToolsCount: 0,
      idleCount: 0,
      keyboardViolationCount: 0,
      screenshotCount: 0,
      resizeCount: 0,
      textSelectionCount: 0,
      multipleMonitorCount: 0,
      riskScore: 0,
      violations: []
    };

    this.devToolInterval = null;
    this.idleTimer = null;
  }

  // =========================
  // ANTI CHEAT
  // =========================

  logViolation = (type) => {
    this.cheatingLog.violations.push({
      type,
      timestamp: moment().format("YYYY-MM-DD HH:mm:ss")
    });
    let { showQuestionScreen, showWelcomeScreen } = this.props;

    switch (type) {

      case "TAB_SWITCH":
        if (showQuestionScreen || showWelcomeScreen) {
          this.cheatingLog.tabSwitchCount++;
          this.cheatingLog.riskScore += 10;
        }
        break;

      case "WINDOW_BLUR":
        this.cheatingLog.blurCount++;
        this.cheatingLog.riskScore += 10;
        break;

      case "EXIT_FULLSCREEN":
        this.cheatingLog.fullscreenExitCount++;
        this.cheatingLog.riskScore += 20;
        break;

      case "COPY_ATTEMPT":
        this.cheatingLog.copyCount++;
        this.cheatingLog.riskScore += 15;
        break;

      case "PASTE_ATTEMPT":
        this.cheatingLog.pasteCount++;
        this.cheatingLog.riskScore += 15;
        break;

      case "CUT_ATTEMPT":
        this.cheatingLog.cutCount++;
        this.cheatingLog.riskScore += 15;
        break;

      case "RIGHT_CLICK":
        this.cheatingLog.rightClickCount++;
        this.cheatingLog.riskScore += 5;
        break;

      case "PAGE_REFRESH":
        this.cheatingLog.refreshCount++;
        this.cheatingLog.riskScore += 25;
        break;

      // case "DEVTOOLS_OPEN":
      //   this.cheatingLog.devToolsCount++;
      //   this.cheatingLog.riskScore += 30;
      //   break;

      case "USER_IDLE":
        this.cheatingLog.idleCount++;
        this.cheatingLog.riskScore += 5;
        break;

      case "KEYBOARD_SHORTCUT":
        this.cheatingLog.keyboardViolationCount++;
        this.cheatingLog.riskScore += 20;
        break;

      case "SCREENSHOT":
        this.cheatingLog.screenshotCount++;
        this.cheatingLog.riskScore += 15;
        break;

      case "WINDOW_RESIZE":
        this.cheatingLog.resizeCount++;
        this.cheatingLog.riskScore += 5;
        break;

      case "TEXT_SELECTION":
        this.cheatingLog.textSelectionCount++;
        this.cheatingLog.riskScore += 5;
        break;

      case "MULTIPLE_MONITOR":
        this.cheatingLog.multipleMonitorCount++;
        this.cheatingLog.riskScore += 20;
        break;

      default:
        break;
    }

    console.log("tabSwitchCount--->", this.cheatingLog.tabSwitchCount);

    let { saveTabSwitchAnsInsightx, recordCheatLog, submitBlock } = this.props;

    recordCheatLog(this.cheatingLog);

    let tabSwitchCount = this.cheatingLog.tabSwitchCount;
    let { warningShown, lastWarning } = this.state;

    if (tabSwitchCount === 3 || tabSwitchCount === 4) {
      if (!lastWarning) {
        if (tabSwitchCount === 4) {
          this.setState({ warningShown: false, lastWarning: true });
        }
      }
      if (!warningShown) {
        this.setState({ showWarningModal: true, warningShown: true });
      }
    }

    if (tabSwitchCount >= 7) {
      this.setState({ showRestrictModal: true });
      // setTimeout(() => {
      //   this.setState({ showRestrictModal: false });
      // }, 5000)
      if (!submitBlock) {
        saveTabSwitchAnsInsightx();
      }
    }

  };


  initAntiCheat = () => {

    // Tab switch
    this.visibilityHandler = () => {
      if (document.hidden) {
        this.logViolation("TAB_SWITCH");
      }
    };

    document.addEventListener(
      "visibilitychange",
      this.visibilityHandler
    );

    // Window focus lost
    this.blurHandler = () => {
      this.logViolation("WINDOW_BLUR");
    };

    window.addEventListener(
      "blur",
      this.blurHandler
    );

    // Fullscreen exit
    this.fullscreenHandler = () => {
      if (!document.fullscreenElement) {
        this.logViolation("EXIT_FULLSCREEN");
      }
    };

    document.addEventListener(
      "fullscreenchange",
      this.fullscreenHandler
    );

    // Copy
    this.copyHandler = () => {
      this.logViolation("COPY_ATTEMPT");
    };

    document.addEventListener(
      "copy",
      this.copyHandler
    );

    // Paste
    this.pasteHandler = () => {
      this.logViolation("PASTE_ATTEMPT");
    };

    document.addEventListener(
      "paste",
      this.pasteHandler
    );

    // Right click
    this.contextHandler = (e) => {
      e.preventDefault();
      this.logViolation("RIGHT_CLICK");
    };

    document.addEventListener(
      "contextmenu",
      this.contextHandler
    );

    // Refresh/close
    this.beforeUnloadHandler = (e) => {
      this.logViolation("PAGE_REFRESH");

      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener(
      "beforeunload",
      this.beforeUnloadHandler
    );

    // Dev tools
    this.devToolInterval = setInterval(() => {

      const threshold = 160;

      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        this.logViolation("DEVTOOLS_OPEN");
      }

    }, 1000);

    // Idle
    const resetIdle = () => {

      clearTimeout(this.idleTimer);

      this.idleTimer = setTimeout(() => {
        this.logViolation("USER_IDLE");
      }, 60000);
    };

    ["mousemove", "keypress", "click", "scroll"].forEach(
      (event) => {
        window.addEventListener(
          event,
          resetIdle
        );
      }
    );

    resetIdle();

    // Optional fullscreen
    // document.documentElement.requestFullscreen();
  };

  componentDidMount() {

    // Initialize anti cheat


    this.initAntiCheat();

  }

  componentWillUnmount() {

    clearInterval(this.devToolInterval);
    clearTimeout(this.idleTimer);

    document.removeEventListener(
      "visibilitychange",
      this.visibilityHandler
    );

    window.removeEventListener(
      "blur",
      this.blurHandler
    );

    document.removeEventListener(
      "fullscreenchange",
      this.fullscreenHandler
    );

    document.removeEventListener(
      "copy",
      this.copyHandler
    );

    document.removeEventListener(
      "paste",
      this.pasteHandler
    );

    document.removeEventListener(
      "contextmenu",
      this.contextHandler
    );

    window.removeEventListener(
      "beforeunload",
      this.beforeUnloadHandler
    );
  }

  closeWarningModal = () => {
    this.setState({ showWarningModal: false });
  }


  finalSubmitMessage = (value, type) => {
    if (type === "SAVE") {
      let { saveAnswers, submitBlock } = this.props;
      if (!submitBlock) {
        saveAnswers();
      }
    }
    this.setState({ showFinalSubmitModal: value });
  }

  render() {
    let { showFinalSubmitModal, showWarningModal, showRestrictModal } = this.state;

    let {
      answeredCount, unansweredCount, saveAnswers,
      surveyCounter, getSecondsToTime, surveyScreenData, EditButtonFn, surveyStatus, showWelcomeScreen, questionsList, getTheme, SurveyAttributes, surveyLanguageCode, functionNameVariable, welcomeTextDislay, goToInstructionPage, instructionPage, LabelObj, instructionTextDislay, goToQuestionPage, afterSubmitData, showQuestionScreen, submitSucces, completedMilestone, CurrQuesIndex, changeType, prevQues, clicked, isMobile, ansNPSInput, nextQues, submitMandatory, submitBlock, showThankyouScreen, alreadySubmitted, disclaimer, isDisclaimer, consent, showThankYouDisclaimer, disclaimerCheck, closeDisclaimer, bgType, bgColor, hexToRgbA, bgImage, surveytitle, handleRadio, ansTextBoxChange1, handleCheckInput, answersList,
      showViewReportThankYouButton, ShowSubmitButton // showFeedbackModal, closeFeedbackModal, selectedOption, check, onLogout, getAssessmenrEmployeeDetailsData, handleReport, surveyLanguageName, handleLanguage, LanguageList, themeType, handleFeedbackInput, submitFeedback, unattemptList, showRedFlag, , timeCounter, getGroupIndex, saveAnswers, submittedAt,
    } = this.props;


    function getTabSwitchRemain(tabSwitchCount) {
      if (tabSwitchCount === 3) {
        return "four"
      } else if (tabSwitchCount === 4) {
        return "three"
      }
    }


    console.log("submitSucces----------->", submitSucces);
    console.log("showQuestionScreen----------->", showQuestionScreen);
    console.log("questionsList----------->", questionsList);
    console.log("CurrQuesIndex----------->", CurrQuesIndex);



    return (
      <>

        <div className="flex flex-col h-screen font-sans"
          style={{
            // backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_survey-light-bg.webp')",
            // getTheme("backgroundImage",'url("/img/survey-bg.jpg")')
          }}
        >
          {/* Welcome Section */}
          {surveyStatus !== 2 && surveyStatus !== 3 ? (
            <>
              {(isDisclaimer && this.state.showDisclaimer) && (consent === "NA" || consent === "NO") ?
                <>
                  {showThankYouDisclaimer || (consent === "NO") ?
                    <>
                      <div>
                        <section className="2xl:w-2/5 xl:w-1/2 lg:w-11/12 md:py-2 py-4 mx-auto lg:px-0 px-4" style={{ height: '75%' }}>
                          <div className="flex justify-center -mt-4">
                            <div className="mt-4" />
                          </div>
                          {/* pragraph */}
                          <div className="pb-24">
                            <div id="chatbot" className="cursor-default text-left mx-4 overflow-y-auto lg:px-14 lg:px-32" >
                              <h1 className="flex justify-center items-center text-center py-2 font-semibold text-2xl">
                                THANK YOU FOR YOUR VALUABLE TIME
                              </h1>
                            </div>
                          </div>
                        </section>
                      </div>

                    </>
                    :
                    <>
                      <div>
                        <section className="2xl:w-2/5 xl:w-1/2 lg:w-11/12 md:py-2 py-4 mx-auto lg:px-0 px-4" style={{ height: '75%' }}>
                          <div className="flex justify-center -mt-4">
                            <div className="mt-4" />
                          </div>

                          <h1 className="text-center py-2 font-bold text-2xl">
                            {/* PRIVACY NOTICE FOR EMPLOYEE ENGAGEMENT SURVEY FOR HAPPINESS WELLBEING AWARD 2024 */}
                            CONSENT FORM
                          </h1>

                          {/* pragraph */}
                          <div className="pb-24">
                            <div id="chatbot" className="cursor-default text-left mx-4 overflow-y-auto lg:px-14 lg:px-32" style={{
                              height: "420px",
                              color: (surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : 'black'
                            }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  functionNameVariable((surveyLanguageCode !== '') ?
                                    (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].disclaimer) ? surveyScreenData.transl[surveyLanguageCode].disclaimer : disclaimer
                                    : disclaimer)
                              }} />
                          </div>

                          <div className="fixed bottom-0  left-0 w-full flex  justify-center bg-white bg-opacity-100">
                            <div>
                              {/* btn */}
                              <div className='flex mb-4'>
                                {/* <input type="checkbox" checked={this.state.disclaimerCheck} onClick={() => this.handleDisclaimerCheck()} className='mx-2' /> */}
                                {/* <p>I agree to the terms and conditions</p> */}
                              </div>

                              <div className='flex  justify-center'>
                                <div className='space-x-2'>
                                  <button onClick={() => closeDisclaimer("NO")}
                                    disabled={!disclaimerCheck}
                                    className={(!disclaimerCheck ? "bg-gray-400" : "bg-white") + "  shadow-lg  font-bold text-lg py-4 px-16 rounded-md   hover:bg-gray-100"}
                                    style={{
                                      background: disclaimerCheck ?

                                        (surveyScreenData && surveyScreenData.buttonColor1) ? surveyScreenData.buttonColor1 : (afterSubmitData.buttonColor1) ? afterSubmitData.buttonColor1 : "#757575"

                                        : "#9CA3AF",
                                      color: (surveyScreenData && surveyScreenData.buttonColor2) ? surveyScreenData.buttonColor2 : (afterSubmitData.buttonColor2) ? afterSubmitData.buttonColor2 : "#757575",
                                    }}
                                  >{
                                      SurveyAttributes("NoButtonText") ? SurveyAttributes("NoButtonText") : "No"
                                    }</button>

                                  <button onClick={() => closeDisclaimer("YES")}
                                    disabled={!disclaimerCheck}
                                    className={(!disclaimerCheck ? "bg-gray-400" : "bg-white") + "  shadow-lg  font-bold text-lg py-4 px-16 rounded-md   hover:bg-gray-100"}
                                    style={{
                                      background: disclaimerCheck ?

                                        (surveyScreenData && surveyScreenData.buttonColor1) ? surveyScreenData.buttonColor1 : (afterSubmitData.buttonColor1) ? afterSubmitData.buttonColor1 : "#757575"

                                        : "#9CA3AF",
                                      color: (surveyScreenData && surveyScreenData.buttonColor2) ? surveyScreenData.buttonColor2 : (afterSubmitData.buttonColor2) ? afterSubmitData.buttonColor2 : "#757575",
                                    }}
                                  >{
                                      SurveyAttributes("YesButtonText") ? SurveyAttributes("YesButtonText") : "Yes"
                                    }</button>
                                  <p
                                    style={{
                                      backgroundColor: (bgType === 1 || afterSubmitData.bgType === 1) ? (bgColor) ? bgColor : (afterSubmitData.bgColor) ? afterSubmitData.bgColor : "#757575" : "#f1f1f1",
                                      // backgroundImage:(bgType===2 || afterSubmitData.bgType===2)? (bgImage) ? bgImage : (afterSubmitData.bgImage)?afterSubmitData.bgImage: null   :null,
                                    }}
                                    className="text-sm py-4 pl-6"> © Powered by <b className="font-semibold">insightplus</b></p>
                                </div>
                              </div>
                            </div>

                          </div>

                        </section>
                      </div>
                    </>
                  }
                </>
                :
                <>

                  {(showWelcomeScreen && questionsList && questionsList.length > 0) ?
                    <>
                      <div>
                        <section className="2xl:w-1/2 xl:w-1/2 lg:w-11/12 md:py-2 py-4 mx-auto lg:px-0 px-4">

                          <h1 className="text-center font-semibold xl:text-4xl md:text-3xl text-3xl py-4 mt-3">
                            {SurveyAttributes("welcomeToText") ? SurveyAttributes("welcomeToText") : "Welcome to "}
                            {(surveyLanguageCode !== '') ?
                              (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].name) ? surveyScreenData.transl[surveyLanguageCode].name : surveytitle
                              : surveytitle
                            }{"!"}</h1>

                          {/* pragraph */}
                          <div className="pb-20 pt-4">
                            <div id="chatbot" className="cursor-default text-left overflow-y-auto text-base" style={{ color: (surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : 'black' }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  functionNameVariable((surveyLanguageCode !== '') ?
                                    (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].welcomeText) ? surveyScreenData.transl[surveyLanguageCode].welcomeText : welcomeTextDislay
                                    : welcomeTextDislay)
                              }} />
                          </div>

                          <div className="fixed bottom-0 left-0 lg:left-12 w-full flex justify-center pt-2  bg-white bg-opacity-100">
                            <div>
                              <button onClick={() => goToInstructionPage()} className="px-16 py-2.5 text-lg bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                                {
                                  SurveyAttributes("StartButtonText") ? SurveyAttributes("StartButtonText") : "Start Test"
                                }
                              </button>
                              <p style={{ backgroundColor: (bgType === 1 || afterSubmitData.bgType === 1) ? (bgColor) ? bgColor : (afterSubmitData.bgColor) ? afterSubmitData.bgColor : "#ffffff" : "#ffffff", }} className="text-sm py-4 md:pl-0 pl-6"> © Powered by <b className="font-semibold">insightplus</b></p>
                            </div>
                          </div>

                        </section>
                      </div>
                    </>
                    : null}


                </>}



              {/* Instruction Section */}

              {instructionPage ?
                <>
                  <div>
                    <section className="2xl:w-2/5 xl:w-1/2 lg:w-11/12 md:py-2 py-4 mx-auto lg:px-0 px-4" style={{ height: '75%' }}>
                      {/* logo */}
                      <div className="flex justify-center -mt-4">
                      </div>

                      <p
                        style={{ color: (surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : 'black' }}
                        className="text-center py-2 font-bold text-2xl">
                        {LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].InstructionLabelText ? LabelObj[surveyLanguageCode].InstructionLabelText : SurveyAttributes("instructionLabel") ? SurveyAttributes("instructionLabel") : "Instructions"}
                      </p>

                      {/* pragraph */}
                      <div className="pb-24">
                        <div id="chatbot" className="cursor-default mx-4 mt-2 overflow-y-auto lg:px-14 lg:pl-32 lg:pr-4" style={{
                          height: "400px",
                          color: (surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : 'black'
                        }}
                          dangerouslySetInnerHTML={{
                            __html:
                              (surveyLanguageCode !== '') ?
                                (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].instructionText) ? surveyScreenData.transl[surveyLanguageCode].instructionText : instructionTextDislay
                                : instructionTextDislay
                          }} />
                      </div>
                      <div className="fixed bottom-0 left-0 w-full flex justify-center bg-white bg-opacity-100">
                        <div>
                          <button onClick={() => goToQuestionPage()} className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                            {
                              SurveyAttributes("ContinueButtonText") ? SurveyAttributes("ContinueButtonText") : "Continue"
                            }
                          </button>

                          <p style={{
                            backgroundColor: (bgType === 1 || afterSubmitData.bgType === 1) ? (bgColor) ? bgColor : (afterSubmitData.bgColor) ? afterSubmitData.bgColor : "#ffffff" : "#ffffff",
                          }}
                            className="text-sm py-4 pl-6"> © Powered by <b className="font-semibold">insightplus</b></p>
                        </div>
                      </div>
                      {/*  */}
                    </section>
                  </div>
                </>
                : null}

              {/* Question Section */}

              {(showQuestionScreen && !submitSucces) ? (
                <div>
                  <div className="h-12 w-full bg-indigo-50 flex items-center ">
                    <div className="w-full mx-auto px-6 flex items-center justify-between">

                      <div className="flex items-center md:space-x-2">
                        <div className="flex items-center space-x-2">
                          <IoTimeOutline size={28} className="text-indigo-600" />
                          <p className="md:text-xl text-sm md:flex hidden">
                            {SurveyAttributes("Remaining")
                              ? SurveyAttributes("Remaining")
                              : "Remaining"}</p>
                        </div>
                        <h1 className=" font-medium md:text-2xl text-sm p-2 ">
                          {getSecondsToTime(surveyCounter)}
                        </h1>
                      </div>


                      <div className="lg:flex items-center space-x-4 hidden">
                        <HiOutlineLightBulb size={28} className="text-indigo-600" />
                        <p className="md:text-xl text-sm text-indigo-600">
                          {SurveyAttributes("Kindly_answer_the_given_question")
                            ? SurveyAttributes("Kindly_answer_the_given_question")
                            : "Kindly answer the given question"}
                        </p>
                      </div>

                      <div className="flex items-center md:space-x-2 space-x-2 text-[#212121] ">
                        <FiCheckCircle size={24} className="text-indigo-600" />
                        <p className="md:text-xl text-sm">{SurveyAttributes("Progress")
                          ? SurveyAttributes("Progress")
                          : "Progress"}</p>
                        <h1 className=" font-medium md:text-2xl text-sm  ">
                          <span className=" text-indigo-600">{completedMilestone}</span>
                          <b className="font-medium  ">
                            {" "}
                            /{" "}
                            {questionsList && questionsList.length > 0
                              ? questionsList.length
                              : 0}
                          </b>
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/* <div className={"md:h-14 h-10 w-full flex items-center bg-indigo-100"}>
                    <div className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full flex items-center justify-center ">
                      <div className="flex items-center space-x-4">
                        <span className="material-symbols-outlined md:text-[2rem] text-[1.5rem]  text-[#5B21B6]" >
                          tips_and_updates
                        </span>
                        <p className="md:text-xl text-sm text-indigo-600 ">
                          {SurveyAttributes("Kindly_answer_the_given_question")
                            ? SurveyAttributes("Kindly_answer_the_given_question")
                            : "Kindly answer the given question"}
                        </p>
                      </div>
                    </div>
                  </div> */}

                  {/* Question survey design OLD */}
                  <section className=" w-full  mx-auto overflow-y-hidden overflow-x-hidden flex h-[calc(140vh-0rem)]">
                    <div className="w-full" >
                      <TransitionGroup>
                        {questionsList && questionsList.length > 0
                          ? questionsList.map((question, questionindex) =>
                            questionindex + 1 === CurrQuesIndex ? (
                              // CurrQuesIndex
                              <CSSTransition
                                timeout={350}
                                classNames={changeType}
                                key={question.id}
                              >
                                <>
                                  {question.templateId === 10 ?
                                    <>
                                      <section className="2xl:w-1/2 xl:w-1/2 lg:w-11/12 md:py-2 py-4 mx-auto lg:px-0 px-4">

                                        <h1 className="text-center font-semibold xl:text-4xl md:text-3xl text-3xl py-4 mt-3">
                                          {SurveyAttributes("welcomeToText") ? SurveyAttributes("welcomeToText") : "Welcome to "}
                                          {(surveyLanguageCode !== '') ?
                                            (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].name) ? surveyScreenData.transl[surveyLanguageCode].name : surveytitle
                                            : surveytitle
                                          }{"!"}</h1>

                                        {/* pragraph */}
                                        <div className="pb-20 pt-4">
                                          <div className="cursor-default text-center text-lg" style={{ color: (surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : 'black' }}>
                                            <p>{question.name}</p>
                                          </div>
                                        </div>

                                        <div className="fixed bottom-0 left-0 lg:left-12 w-full flex justify-center pt-2  bg-white bg-opacity-100">
                                          <div>
                                            <button onClick={() => nextQues(2)} className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                                              {
                                                SurveyAttributes("StartButtonText") ? SurveyAttributes("StartButtonText") : "Start Test"
                                              }
                                            </button>
                                            <p style={{ backgroundColor: (bgType === 1 || afterSubmitData.bgType === 1) ? (bgColor) ? bgColor : (afterSubmitData.bgColor) ? afterSubmitData.bgColor : "#ffffff" : "#ffffff", }} className="text-sm py-4 md:pl-0 pl-6"> © Powered by <b className="font-semibold">insightplus</b></p>
                                          </div>
                                        </div>

                                      </section>

                                    </>
                                    :
                                    <div className="p-6 md:p-8 textblack">
                                      <div className="w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-start h-full">

                                        {/* Left Column: Question/Scenario */}
                                        <div className="relative border border-gray-300 rounded-xl p-5 bg-transparent h-full">
                                          {/* Label Badge */}
                                          <div className="absolute -top-3 left-6 bg-white px-4 py-0 text-lg font-bold">
                                            {"Question"}
                                          </div>

                                          <div className="mt-4 leading-relaxed textblack text-sm md:text-base whitespace-pre-line">
                                            {functionNameVariable(
                                              surveyLanguageCode !==
                                                ""
                                                ? question &&
                                                  question.transl &&
                                                  question.transl[
                                                  surveyLanguageCode
                                                  ] &&
                                                  question.transl[
                                                    surveyLanguageCode
                                                  ].name
                                                  ? question.transl[
                                                    surveyLanguageCode
                                                  ].name
                                                  : question.name
                                                : question.name
                                            )}
                                          </div>
                                        </div>

                                        {/* Right Column: Answers Selection */}
                                        <div className="relative border border-gray-300 rounded-xl p-5 bg-transparent flex flex-col justify-between">
                                          {/* Label Badge */}
                                          <div className="absolute -top-3 left-6 bg-white px-4 py-0 text-lg font-medium">
                                            {"Answers"}
                                          </div>

                                          <div className="space-y-4 mt-4">
                                            {/* NPS Scale 1-10*/}
                                            {question.templateId === 6 || question.templateId === 17 ? (
                                              <>
                                                <NPS
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={
                                                    surveyLanguageCode
                                                  }
                                                  ansNPSInput={ansNPSInput}
                                                  surveyScreenData={
                                                    surveyScreenData
                                                  }
                                                  isMobile={isMobile}
                                                  questionsList={questionsList}
                                                  CurrQuesIndex={CurrQuesIndex}
                                                  nextQues={nextQues}
                                                  SurveyAttributes={SurveyAttributes}
                                                  getTheme={getTheme}
                                                  arrLen={question.templateId === 17 ? 7 : 10}
                                                />
                                              </>
                                            ) : null}

                                            {/* Single Choice */}
                                            {question.templateId === 1 ?
                                              <>
                                                <SingleChoice
                                                  question={question}
                                                  clicked={clicked}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  handleRadio={handleRadio}
                                                  surveyScreenData={surveyScreenData}
                                                  isMobile={isMobile}
                                                />
                                              </>
                                              : null}

                                            {/* Multiple Choice */}
                                            {question.templateId === 2 ?
                                              <>
                                                <MultipleChoice
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  handleCheckInput={handleCheckInput}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                  SurveyAttributes={SurveyAttributes}

                                                />
                                              </>
                                              : null}

                                            {/* Multitext Box */}
                                            {question.templateId === 3 ?
                                              <>
                                                <TextBox
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  SurveyAttributes={SurveyAttributes}
                                                  ansTextBoxChange1={ansTextBoxChange1}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                />
                                              </>
                                              : null}

                                            {/* Multitext Box */}
                                            {question.templateId === 4 ?
                                              <>
                                                <MultiLineText
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  SurveyAttributes={SurveyAttributes}
                                                  ansTextBoxChange1={ansTextBoxChange1}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                />
                                              </>
                                              : null}


                                            {/* Rating Scale */}
                                            {question.templateId === 5 ?
                                              <>
                                                <RatingScale
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  handleRadio={handleRadio}
                                                  surveyScreenData={surveyScreenData}

                                                />
                                              </>
                                              : null}

                                            {/* NPS Scale 0-10*/}
                                            {question.templateId === 16 ? (
                                              <>
                                                <NPSV2
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={
                                                    surveyLanguageCode
                                                  }
                                                  ansNPSInput={ansNPSInput}
                                                  surveyScreenData={
                                                    surveyScreenData
                                                  }
                                                />
                                              </>
                                            ) : null}

                                            {/* Email */}
                                            {question.templateId === 7 ?
                                              <>
                                                <Email
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  ansTextBoxChange1={ansTextBoxChange1}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                  SurveyAttributes={SurveyAttributes}

                                                />
                                              </>
                                              : null}

                                            {/* Number */}
                                            {question.templateId === 8 ?
                                              <>
                                                <Number
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  ansTextBoxChange1={ansTextBoxChange1}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                  SurveyAttributes={SurveyAttributes}

                                                />
                                              </>
                                              : null}

                                            {/* Dropdown */}
                                            {question.templateId === 9 ?
                                              <>
                                                <Dropdown
                                                  question={question}
                                                  clicked={clicked}
                                                  answersList={answersList}
                                                  handleRadio={handleRadio}
                                                  handleDropdownSelect={this.handleDropdownSelect}
                                                  surveyScreenData={surveyScreenData}
                                                />
                                              </>
                                              : null}

                                            {/* Yes/No */}
                                            {question.templateId === 11 ?
                                              <>
                                                <YesNo
                                                  question={question}
                                                  clicked={clicked}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  handleRadio={handleRadio}
                                                  surveyScreenData={surveyScreenData}
                                                />
                                              </>
                                              : null}

                                            {/* Date */}
                                            {question.templateId === 12 ?
                                              <>
                                                <Date
                                                  question={question}
                                                  answersList={answersList}
                                                  surveyLanguageCode={surveyLanguageCode}
                                                  ansTextBoxChange1={ansTextBoxChange1}
                                                  surveyScreenData={surveyScreenData}
                                                  clickOK={this.clickOK}
                                                  SurveyAttributes={SurveyAttributes}

                                                />
                                              </>
                                              : null}

                                          </div>

                                          {/* Action Buttons */}
                                          <div className="flex items-center gap-4 mt-5">
                                            <button onClick={() => prevQues()} className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                                              Back
                                            </button>

                                            {questionsList && questionsList.length > 0 &&
                                              questionsList.length !== (CurrQuesIndex) &&
                                              <button onClick={() => nextQues(2)} className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                                                Next
                                              </button>}


                                            {ShowSubmitButton || (questionsList && questionsList.length > 0 &&
                                              questionsList.length === (CurrQuesIndex)) ?
                                              <>
                                                <div className="px-4 text-center text-red-500">{submitMandatory}</div>
                                                {/* <button onClick={() => !submitBlock ? this.saveAnswers() : {}} */}
                                                <button onClick={() => !submitBlock ? this.finalSubmitMessage(true) : {}}
                                                  className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700 transition shadow-md">
                                                  Submit
                                                </button>
                                              </>
                                              : null}

                                          </div>
                                        </div>

                                      </div>
                                      <div className="w-full">
                                        <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                                          <div className="w-full flex justify-end">
                                            <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                              <div className="flex md:justify-end justify-center  w-full">
                                                <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                                  © Powered by
                                                  <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                                    HappyPlus
                                                  </b>
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }


                                </>
                              </CSSTransition>
                            ) : null
                          )
                          : null}
                      </TransitionGroup>


                    </div>
                  </section>

                </div>
              ) : null}

              {showThankyouScreen ? (
                <>
                  <div className="h-screen flex items-center justify-center">
                    <section className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full py-10   flex md:space-x-10  items-start  ">
                      <div className=" lg:w-4/6 w-full mx-auto space-y-10 md:px-10   text-center">
                        <div className="space-y-4 text-white/80 text-base font-normal ">
                          <div className="flex flex-col justify-center items-center md:space-y-10 space-y-6">
                            <div className="md:w-[12rem] w-[10rem] md:h-[12rem] h-[10rem] rounded-full bg-white/10 flex justify-center items-center"
                              style={{ background: getTheme('lightblue', hexToRgbA('#FFFFFF', '0.10')) }}>
                              <div style={{ background: getTheme('textblue', hexToRgbA('#FFFFFF', '0.10')) }} className="md:w-[10rem] w-[8rem] h-[8rem] md:h-[10rem] rounded-full bg-white/20 flex justify-center items-center">
                                <span className="material-icons md:text-[4.5rem] text-[4rem] text-white">
                                  thumb_up
                                </span>
                              </div>
                            </div>
                            <h1 className="lg:text-5xl md:text-4xl text-3xl font-bold text-white" style={{ color: getTheme('text', '#FFFFFF') }}>
                              {EditButtonFn("ThankYou", "Thank You!")}
                            </h1>
                          </div>
                          {/*  <h1 className="  py-2 font-normal md:text-2xl text-xl text-white/100  " style={{ color: getTheme('text', '#FFFFFF') }}>
                            {EditButtonFn("ThankYouDesc", "For taking the assessment survey, your report will be generated soon. You can check your report after 5 minutes in the profile section.")}
                          </h1> */}
                        </div>


                        <div className="fixed bottom-0 left-0 w-full">
                          <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                            <div className="w-full flex justify-end">
                              <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                <div className="flex md:justify-end justify-center  w-full">
                                  <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                    © Powered by
                                    <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                      HappyPlus
                                    </b>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/*  */}
                    </section>
                  </div>
                </>
              ) : null}


              {showWarningModal ?
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
                  <div
                    className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden animate-fadeIn"
                  >
                    {/* Header */}
                    <div className="px-6 pt-8 pb-4 text-center">
                      <div className="mx-auto w-20 h-20 rounded-full bg-yellow-100 flex items-center justify-center">
                        <span className="material-icons text-5xl text-yellow-600">
                          warning_amber
                        </span>
                      </div>

                      <h2 className="mt-5 text-2xl font-bold text-gray-800">
                        Warning!
                      </h2>

                      <p className="mt-4 text-gray-600 leading-7">
                        We detected that you have switched tabs multiple times during the test.
                      </p>

                      <p className="mt-3 text-gray-700 leading-7">
                        <span className="font-semibold text-yellow-600">
                          {getTabSwitchRemain(this.cheatingLog.tabSwitchCount)} more tab switch
                        </span>{" "}
                        will result in your test being{" "}
                        <span className="font-bold text-red-600">
                          submitted automatically.
                        </span>
                      </p>
                    </div>

                    {/* Alert Box */}
                    <div className="mx-6 mb-6 rounded-lg border border-red-200 bg-red-50 p-4 flex items-start">
                      <span className="material-icons text-red-600 mr-3 mt-0.5">
                        report_problem
                      </span>

                      <div>
                        <p className="font-semibold text-red-700">
                          Please stay on this test screen.
                        </p>

                      </div>
                    </div>

                    {/* Footer */}
                    <div className="bg-gray-50 px-6 py-5 flex justify-end">
                      <button
                        onClick={() => this.closeWarningModal()}
                        className="px-6 py-3 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-white font-semibold transition-all shadow-md"
                      >
                        I Understand
                      </button>
                    </div>
                  </div>
                </div>
                : null}


              {showRestrictModal ?
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                  <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden">

                    {/* Top Accent */}
                    <div className="h-2 bg-red-500" />

                    {/* Content */}
                    <div className="px-8 py-8 text-center">

                      {/* Icon */}
                      <div className="mx-auto w-24 h-24 rounded-full bg-red-100 flex items-center justify-center">
                        <span className="material-icons text-6xl text-red-600">
                          gpp_bad
                        </span>
                      </div>

                      {/* Title */}
                      <h2 className="mt-6 text-3xl font-bold text-gray-800">
                        Test Submitted
                      </h2>

                      {/* Description */}
                      <p className="mt-4 text-gray-600 leading-7 text-base">
                        We detected that you switched browser tabs
                        <span className="font-semibold"> more than 6 times </span>
                        during the assessment.
                      </p>

                      {/* Alert */}
                      <div className="mt-6 rounded-xl border border-red-200 bg-red-50 p-5 text-left">
                        <div className="flex items-start">
                          <span className="material-icons text-red-600 mr-3 mt-1">
                            report_problem
                          </span>

                          <div>
                            <h4 className="font-semibold text-red-700">
                              Assessment Integrity Policy
                            </h4>

                            <p className="mt-1 text-sm text-red-600 leading-6">
                              Multiple tab switches violate the assessment guidelines.
                              As a result, your assessment has been
                              <span className="font-semibold">
                                {" "}submitted automatically.
                              </span>
                            </p>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                : null}


              {showFinalSubmitModal ?
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                  <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl">

                    {/* Top Accent */}
                    <div className="h-2 bg-indigo-600" />

                    {/* Content */}
                    <div className="px-8 py-8 text-center">

                      {/* Icon */}
                      <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-indigo-100">
                        <span className="material-icons text-6xl text-indigo-600">
                          fact_check
                        </span>
                      </div>

                      {/* Title */}
                      <h2 className="mt-6 text-3xl font-bold text-gray-800">
                        Submit Assessment?
                      </h2>

                      {/* Description */}
                      {/* <p className="mt-4 text-base leading-7 text-gray-600">
                        You have answered{" "}
                        <span className="font-semibold text-indigo-600">
                          {answeredCount}
                        </span>{" "}
                        questions and{" "}
                        <span className="font-semibold text-indigo-600">
                          {unansweredCount}
                        </span>{" "}
                        questions are still unanswered.
                      </p> */}

                      <p className="mt-3 text-base leading-6 text-gray-600">
                        Once you submit, you won't be able to modify your responses.
                        Are you sure you want to submit your assessment?
                      </p>

                      {/* Information Box */}
                      {/* <div className="mt-6 rounded-xl border border-indigo-200 bg-indigo-50 p-5 text-left">
                        <div className="flex items-start">
                          <span className="material-icons mr-3 mt-1 text-indigo-600">
                            info
                          </span>

                          <div>
                            <h4 className="font-semibold text-indigo-700">
                              Submission Confirmation
                            </h4>

                            <p className="mt-1 text-sm leading-6 text-indigo-600">
                              Please review your responses before submitting. After submission,
                              your assessment will be finalized and no further changes will be
                              allowed.
                            </p>
                          </div>
                        </div>
                      </div> */}

                      {/* Buttons */}
                      <div className="mt-8 flex gap-4">
                        <button
                          type="button"
                          onClick={() => this.finalSubmitMessage(false)}
                          className="flex-1 rounded-xl border border-gray-300 px-5 py-3 font-medium text-gray-700 transition hover:bg-gray-100"
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            this.finalSubmitMessage(false, "SAVE");
                          }} className="flex-1 rounded-xl bg-indigo-600 px-5 py-3 font-semibold text-white shadow-md transition hover:bg-indigo-700 active:scale-[0.98]"
                        >
                          Yes, Submit Test
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
                : null}


            </>
          ) : null}




          {(surveyStatus === 2 &&
            !(questionsList && questionsList.length > 0)) ||
            alreadySubmitted ? ( //already done
            <div className="">
              <section className="xl:w-3/6 lg:w-4/6  py-6 mx-auto lg:px-0 md:px-6 px-6 ">
                <div className="flex justify-center pb-16 mt-12">

                </div>
                <div className="flex items-center h-full justify-center">
                  <div className="text-center text-white">
                    <div className="flex justify-center pb-8">
                      <img
                        alt="Survey Done"
                        src="pictures/surveydone.png"
                        className="md:w-auto w-6/6 "
                      />
                    </div>
                    <h1
                      className="font-bold text-gray-800 md:text-4xl text-3xl tracking-widest leading_lose leading-10"
                      style={{}}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          color:
                            surveyScreenData && surveyScreenData.textColor
                              ? surveyScreenData.textColor
                              : "black",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:

                            SurveyAttributes("AlreadyText")
                              ? "<h1>" +
                              SurveyAttributes("AlreadyText") +
                              "</h1>"
                              : "<h1>Survey Is Already Submitted !</h1>",
                        }}
                      />
                    </h1>
                    <p className="text-xl opacity-80 font-light py-2"></p>
                  </div>
                </div>
              </section>


              {false && <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
              >
                <p
                  className="text-sm py-4"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © Powered by <b className="font-semibold">insightplus</b>
                </p>
              </div>}
            </div>
          ) : null}

          {/* survey expired page ----------------------------------------------------------------------------------------------- */}

          {surveyStatus === 3 &&
            !(questionsList && questionsList.length > 0) ? ( //expired
            <div>
              <section className="lg:w-4/6   mx-auto lg:px-0 md:px-6 px-2 flex items-center py-32 justify-center overflow-y-hidden">
                {/* logo */}
                <div>
                  <div className="flex justify-center">
                    <img src="img/expiry.png" alt="Survey Expired" className="w-32" />
                  </div>
                  <div className="flex items-center h-full justify-center">
                    <div
                      className="text-center font-bold text-2xl mt-6"
                      style={{
                        textAlign: "center",
                        color:
                          surveyScreenData && surveyScreenData.textColor
                            ? surveyScreenData.textColor
                            : "black",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:

                          SurveyAttributes("ExpiryText")
                            ? "<h1>" +
                            SurveyAttributes("ExpiryText") +
                            "</h1>"
                            : "<h1>This Survey is <br>Expired!</h1>",
                      }}
                    />
                  </div>
                </div>
              </section>
              {false && <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
              >
                <p
                  className="text-sm py-4"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © Powered by <b className="font-semibold">insightplus</b>
                </p>
              </div>}
            </div>
          ) : null}

        </div>





      </>
    );
  }
}

function mapStateToProps(state) {
  ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users,
  };
}

export default connect(mapStateToProps)(Survey);
